import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { previewEmailTemplate } from '../../../../services/SettingsService';

const DEBOUNCE_MS = 400;

// Live preview of the branded order email. The HTML comes from the backend renderer, with the
// subject and ALL unsaved layout settings from the form laid over the saved ones, through the
// same function that builds the email that is actually sent — so what you see is what is sent.
// Rendered in a fully sandboxed iframe: no scripts, no navigation.
export default function BrandedEmailPreview({ templateKey, subject, settings }) {
    const { t } = useTranslation();
    const [html, setHtml] = useState('');
    const [renderedSubject, setRenderedSubject] = useState('');
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        let cancelled = false;
        const timer = setTimeout(async () => {
            try {
                const res = await previewEmailTemplate(templateKey, { subject, settings });
                if (cancelled) return;
                setHtml(res.data.html);
                setRenderedSubject(res.data.subject);
                setFailed(false);
            } catch {
                if (!cancelled) setFailed(true);
            }
        }, DEBOUNCE_MS);
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [templateKey, subject, settings]);

    return (
        <div className="email-preview-pane border rounded bg-white h-100">
            <div className="border-bottom px-3 py-2 bg-light">
                <small className="text-muted d-block">{t('emailTemplates.preview.subjectLabel')}</small>
                <strong>{renderedSubject || <span className="text-muted fst-italic">{t('emailTemplates.preview.emptySubject')}</span>}</strong>
            </div>
            {failed && <div className="alert alert-warning m-2 py-2">{t('emailTemplates.preview.error')}</div>}
            <iframe
                className="email-preview-frame"
                title={t('emailTemplates.preview.label')}
                sandbox=""
                srcDoc={html}
            />
        </div>
    );
}
